/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-10 13:30:21
 */
import { useState } from "react";
import { getTrainCourseList, queryCategoryTree } from "@root/common/service";
import { Tabs, Pagination, Radio, Carousel } from "antd";
import CourseList from "@root/components/courselist";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import {
  handleTreelData,
  postLeaveAdvertisementTimeMap,
} from "@root/common/utils";
import "./_style.scss";
const { TabPane } = Tabs;
const pageSize = 12;
export default function CoreCourse() {
  const [total, setTotal] = useState(1);
  const [searchParam, setSearchParam] = useState<{
    subjectIdList: any[];
    centerCategoryIdList: any[];
    courseLevelType: number;
    courseOrderType: number;
  }>({
    subjectIdList: [], //学科列表
    centerCategoryIdList: [], // 中心列表
    courseLevelType: 111, //课程级别
    courseOrderType: 1, //排序类型
  });
  const { publicSearchKey } = useSelector((state: RootState) => state.userInfo);
  const [courseList, setCourseList] = useState([]);
  const { xy_navigation } = useSelector(
    (item: RootState) => item.advertisementData
  );
  // 中心分类
  const [categoryTree, setCategoryTree] = useState([]);
  // 所选中心类型
  const [centerCategoryId, setCenterCategoryId] = useState("");
  // 获取培训课程
  const queryTrainCourseList = async (param: any, page = 1) => {
    param.centerCategoryId = centerCategoryId;
    const {
      data: { rows, total },
    } = await getTrainCourseList(param, {
      pageNum: page,
      pageSize,
    });
    setCourseList(rows);
    setTotal(total);
  };
  useEffect(() => {
    queryTrainCourseList(searchParam);
  }, [searchParam, centerCategoryId]);
  useEffect(() => {
    queryTrainCourseList({
      searchValue: publicSearchKey,
    });
  }, [publicSearchKey]);
  // 排序搜索
  const onChange = (key: string) => {
    queryTrainCourseList({
      ...searchParam,
      courseOrderType: key,
    });
  };
  /**
   * 获取中心分类
   */
  const getCategoryTree = async () => {
    const { data } = await queryCategoryTree();
    setCategoryTree(handleTreelData(data));
  };
  useEffect(() => {
    getCategoryTree();
  }, []);
  useEffect(() => {
    var startTime = new Date().valueOf() / 1000;
    return () => {
      postLeaveAdvertisementTimeMap(
        xy_navigation,
        startTime,
        xy_navigation.length,
        2
      );
    };
  }, []);
  return (
    <div className="course_train">
      <Carousel
        autoplay
        autoplaySpeed={2000}
        dots={{ className: "banner-custom-dots" }}
      >
        {xy_navigation.length > 0 &&
          xy_navigation.map((bannerItem: any) => {
            return (
              <div
                className="banner-item"
                onClick={async () => {
                  bannerItem.url && window.open(bannerItem.url);
                }}
              >
                <img
                  src={bannerItem.imageUrl}
                  alt=""
                  height={"150px"}
                  width={"100%"}
                />
              </div>
            );
          })}
      </Carousel>
      <div className="select_type">
        <h3>全部：</h3>
        <Radio.Group buttonStyle="solid" value={centerCategoryId}>
          <Radio.Button
            onChange={() => {
              setCenterCategoryId("");
            }}
            value=""
          >
            全部
          </Radio.Button>
        </Radio.Group>
      </div>
      {categoryTree.map((item: any, index: number) => {
        return (
          <div className="select_type">
            <h3>{item.label}：</h3>
            <Radio.Group
              value={centerCategoryId}
              onChange={(e) => {
                setCenterCategoryId(e.target.value);
              }}
              buttonStyle="solid"
            >
              {item.children.map((child: any) => (
                <Radio.Button value={child.value}>{child.label}</Radio.Button>
              ))}
            </Radio.Group>
          </div>
        );
      })}
      <div>
        <Tabs defaultActiveKey="1" onChange={onChange}>
          <TabPane tab="综合" key="1">
            <CourseList data={courseList} />
          </TabPane>
          <TabPane tab="最新" key="2">
            <CourseList data={courseList} />
          </TabPane>
          <TabPane tab="最热" key="3">
            <CourseList data={courseList} />
          </TabPane>
        </Tabs>
        <div className="home_page_container">
          <Pagination
            defaultCurrent={1}
            total={total}
            pageSize={12}
            onChange={(page) => {
              queryTrainCourseList(searchParam, page);
            }}
            showSizeChanger={false}
          />
        </div>
      </div>
    </div>
  );
}
